const ZillowSubscriptionConstants = {
    ZRM_REVIEWS: {
        name: 'ZRM_REVIEWS',
        persistentString: 'zrm_reviews',
    },
};

export default ZillowSubscriptionConstants;
